export default __webpack_public_path__ + "static/media/ic-map-purple.43622ff1.svg";